/** Indicador do Customer Share */
export interface CustomerShareIndicador {
    id: number;
    nome: string;
    badge: string;
    backgroundColor: string;
    color: string;
}

export const customerShareIndicadorOtimo: CustomerShareIndicador = {
    id: 1,
    nome: 'Ótimo',
    badge: 'badge badge-customer-share-indicador badge-customer-share-indicador-otimo',
    backgroundColor: '#b2f1cb',
    color: '#20c764'
};

export const customerShareIndicadorBom: CustomerShareIndicador = {
    id: 2,
    nome: 'Bom',
    badge: 'badge badge-customer-share-indicador badge-customer-share-indicador-bom',
    backgroundColor: '#c9def6',
    color: '#237dd8'
};

export const customerShareIndicadorRazoavel: CustomerShareIndicador = {
    id: 3,
    nome: 'Razoável',
    badge: 'badge badge-customer-share-indicador badge-customer-share-indicador-razoavel',
    backgroundColor: '#ffedcc',
    color: '#F97316'
};

export const customerShareIndicadorRuim: CustomerShareIndicador = {
    id: 4,
    nome: 'Ruim',
    badge: 'badge badge-customer-share-indicador badge-customer-share-indicador-ruim',
    backgroundColor: '#fcd3d1',
    color: '#f55e59'
};

export const customerShareIndicadores: CustomerShareIndicador[] = [
    customerShareIndicadorOtimo,
    customerShareIndicadorBom,
    customerShareIndicadorRazoavel,
    customerShareIndicadorRuim
];

/** Obtem o indicador do Customer Share */
export function getCustomerShareIndicador(indicador: number): CustomerShareIndicador {
    for (let i = 0; i < customerShareIndicadores.length; i++) {
        const customerShareIndicador = customerShareIndicadores[i];
        if (customerShareIndicador.id === indicador) {
            return customerShareIndicador;
        }
    }
    return null;
}

/** Verifica se o indicador de customer share é ótimo */
export function isCustomerShareIndicadorOtimo(indicador: number): boolean {
    return indicador === customerShareIndicadorOtimo.id;
}

/** Verifica se o indicador de customer share é bom */
export function isCustomerShareIndicadorBom(indicador: number): boolean {
    return indicador === customerShareIndicadorBom.id;
}

/** Verifica se o indicador de customer share é razoável */
export function isCustomerShareIndicadorRazoavel(indicador: number): boolean {
    return indicador === customerShareIndicadorRazoavel.id;
}

/** Verifica se o indicador de customer share é ruim */
export function isCustomerShareIndicadorRuim(indicador: number): boolean {
    return indicador === customerShareIndicadorRuim.id;
}
